<template>
  <form
      :id="'ks_form'+_uid"
      :key="componentRefresh"
      :autocomplete="autocomplete"
      :class="[classes]"
      v-if="showComponent && onReady "
  >
    <slot :record="data_provider_ref[type]" :dataProvider="data_provider_ref"></slot>
    <slot name="header"></slot>
    <slot name="body" :record="data_provider_ref[type]" :dataProvider="data_provider_ref"></slot>
    <slot name="footer"></slot>
  </form>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';
import onMountedDataProvider from '../../mixins/onMountedDataProvider';
import _ from 'lodash';

export default {
  /**
   tag
   name: ks-chart
   description: chart component
   **/
  name: 'data-form',
  mixins: [checkPermissions, onMountedDataProvider],
  props: {
    /**
     attribute
     name: autocomplete
     description: autocomplete
     **/
    autocomplete: {
      type: String,
      default: "off"
    },
    /**
     attribute
     name: submitDelay
     description: submitDelay
     **/
    submitDelay: {
      type: Number,
      default: 0 //seconds
    },
    /**
     attribute
     name: submitOnChange
     description: submitOnChange
     **/
    submitOnChange: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: formType
     description: formType
     **/
    formType: {
      type: String,
      default: 'record'
    },
    /**
     attribute
     name: dataProvider
     description: dataProvider
     **/
    dataProvider: {
      required: true,
      default: null
    },
    /**
     attribute
     name: classes
     description: classes
     **/
    classes: {
      type: String,
      default: null
    }
  },
  watch: {
    filters: {
      handler: function (value, oldValue) {
        if (oldValue && Object.keys(oldValue).length !== 0) {
          if (this.submitOnChange && this.data_provider_ref.l_initialized) {
            if (this.data_provider_ref.l_preventFormSubmitOnFilterChangeByCode) {
              return false;
            }
            this.clearMode(value, oldValue);
            if (this.timeout) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              if (this.consoleLogs) console.log("data-form loadList")
              this.data_provider_ref.loadList();
            }, this.submitDelay * 1000);
          }
        }
      },
      deep: true
    }
  },
  computed: {
    type() {
      if (this.formType == 'filter') {
        return 'filters';
      } else {
        return 'record';
      }
    },
    filters() {
      return Object.assign({}, this.data_provider_ref.filters);
    }
  },
  methods: {
    clearMode(value, oldValue){
      try{
        let aux1 = JSON.parse(JSON.stringify(value));
        let aux2 = JSON.parse(JSON.stringify(oldValue));
        if(typeof aux1['campaign_id'] !== 'undefined') delete aux1['campaign_id'];
        if(typeof aux1['facility_id'] !== 'undefined') delete aux1['facility_id'];
        if(typeof aux1['facility_id_csv'] !== 'undefined') delete aux1['facility_id_csv'];
        if(typeof aux2['campaign_id'] !== 'undefined') delete aux2['campaign_id'];
        if(typeof aux2['facility_id'] !== 'undefined') delete aux2['facility_id'];
        if(typeof aux2['facility_id_csv'] !== 'undefined') delete aux2['facility_id_csv'];
        console.log("clear Mode 123456778")
        if(!_.isEqual(aux1, aux2)) this.data_provider_ref.clearSelectedMode();
      }catch(err){
        console.log(err);
      }
    }
  },
  async mounted() {
    await this.onMountedDataProvider();
  },
  data() {
    return {
      timeout: null
    }
  }
}
</script>
